import { interfaces } from '@daas-consulting/core-cross-interfaces';
import { formatDate } from './format-date';
import { dateTimeFormatEsAR } from './i18n';

interface GetCriteriaOptions {
  key: string;
  value: unknown;
  labels: Map<string, string>;
  formatter?: Intl.DateTimeFormat;
}

export function getCriteria({
  value,
  key,
  labels,
  formatter = dateTimeFormatEsAR,
}: GetCriteriaOptions): interfaces.Criteria[] {
  if (!value) {
    return [];
  }

  const val = formatDate(value, formatter);
  const rv = [
    {
      key,
      label: labels.get(key) || key,
      value: val,
      rawValue: value,
    },
  ];
  return rv;
}
